import { MRT_Cell, MRT_ColumnDef } from "material-react-table"
import { Box, IconButton } from "@mui/material"
import EditIcon from "../../../assets/icons/edit.svg"
import store from "../../redux"
import { useMemo } from "react"
import HuddleAuditCell from "../../components/Table/Cell/HuddleAuditCell"
import { splitFirstCap } from "../../../helper/utils"
import { colors } from "../../../styles/commonStyles"
import HuddleProviderSummaryHeader from "../../components/Table/Header/HuddleProviderSummaryHeader"
import { roundUp } from "../../../helper/utils/formatting"

const currentState: any = store.getState()

const huddleSummaryData: any = currentState?.huddle?.huddleSummaryData

console.log("huddleSummaryData", huddleSummaryData)

const dailyProductionGoalValue = huddleSummaryData?.dailyProductionGoalValue
const dailyCollectionGoalValue = huddleSummaryData?.dailyCollectionGoalValue

export const percentFormatter = ({ renderedCellValue, row }: any) => {
  return `${parseFloat(renderedCellValue || "0").toFixed(2)} %`
}

export const amountFormatter = ({ renderedCellValue }: any) =>
  renderedCellValue
    ? `$ ${parseInt(renderedCellValue || "0")
        .toLocaleString
        //   undefined,
        //   {
        //   minimumFractionDigits: 2,
        //   maximumFractionDigits: 2,
        // }
        ()}`
    : renderedCellValue

const colorDot = (red: boolean) => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="8" fill={red ? "red" : "green"} />
    </svg>
  )
}

// const stringToNum = (val: string, dollar?: boolean) => {

//   console.log("val", typeof val);

//   val = val.substring(1);

//   console.log("val", val);
//   return parseFloat(val);
// }

export const YesterdayTableConfig: MRT_ColumnDef<any>[] = [
  {
    header: "Provider",
    accessorKey: "provider_name",
    size: 220,
    enableEditing: false,
    enableSorting: false,
    muiTableBodyCellProps: {
      align: "left",
      sx: {
        height: "48px",
        border: "0.5px solid #E4E4E4",
        boxShadow: "#00000022 1.95px 0px 2.6px",
        color: "black",
        fontWeight: "600",
      },
    },
  },
  {
    header: "Provider Type",
    accessorKey: "provider_type",
    enableEditing: false,
  },
  {
    header: "Speciality",
    accessorKey: "specialty",
    enableEditing: false,
  },
  {
    header: "Hourly Production Goal",
    size: 220,
    accessorKey: "hourly_production_goal",
    Cell: amountFormatter,
    enableEditing: false,
    enableSorting: false,
  },
  {
    header: "Hours",
    accessorKey: "hours",
    enableSorting: false,
    Cell: ({ renderedCellValue, table, cell }) => {
      const editingEnabled = table?.options?.enableEditing
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: editingEnabled ? "space-between" : "center",
            alignItems: "center",
          }}
        >
          {renderedCellValue}{" "}
          {editingEnabled && (
            <IconButton
              disableTouchRipple
              onClick={() => {
                table.setEditingCell(cell)
              }}
            >
              <img
                src={EditIcon}
                height={"12px"}
                alt="edit hours"
                style={{ cursor: "pointer" }}
              />
            </IconButton>
          )}
        </Box>
      )
    },
  },
  {
    header: "Daily Production Goal",
    size: 220,
    accessorKey: "daily_production_goal",
    Cell: amountFormatter,
    enableEditing: false,
    enableSorting: false,
  },
  {
    header: "Produced",
    accessorKey: "produced",
    Cell: amountFormatter,
    enableEditing: false,
    enableSorting: false,
  },
  {
    header: "Difference",
    accessorKey: "difference",
    Cell: amountFormatter,
    enableEditing: false,
    enableSorting: false,
  },
  {
    header: "Cancelled/No show",
    accessorKey: "patients_who_cancelled_or_no_showed",
    enableEditing: false,
    enableSorting: false,
  },
  {
    header: "Not Scheduled",
    accessorKey: "patients_who_did_not_schedule",
    enableEditing: false,
    enableSorting: false,
  },
]

export const TodaysTableConfig: MRT_ColumnDef<any>[] = [
  {
    header: "Provider",
    accessorKey: "provider_name",
    size: 200,
    enableSorting: false,
    muiTableBodyCellProps: {
      align: "left",
      sx: {
        height: "48px",
        border: "0.5px solid #E4E4E4",
        boxShadow: "#00000022 1.95px 0px 2.6px",
        color: "black",
        fontWeight: "600",
      },
    },
  },
  {
    header: "Provider Type",
    accessorKey: "provider_type",
  },
  {
    header: "Speciality",
    accessorKey: "specialty",
  },
  {
    header: "Hourly Production Goal",
    size: 200,
    accessorKey: "hourly_production_goal",
    Cell: amountFormatter,
    enableSorting: false,
  },
  {
    header: "Scheduled Hours",
    accessorKey: "scheduled_hours",
    enableSorting: false,
  },
  {
    header: "Daily Production Goal",
    size: 200,
    accessorKey: "daily_production_goal",
    Cell: amountFormatter,
    enableSorting: false,
  },
  {
    header: "Scheduled Production",
    size: 200,
    accessorKey: "scheduled_production",
    Cell: amountFormatter,
    enableSorting: false,
  },
  {
    header: "Difference",
    accessorKey: "difference",
    Cell: amountFormatter,
    enableSorting: false,
  },
  {
    header: "Patients With Balances",
    accessorKey: "patients_with_balances",
    size: 200,
    enableSorting: false,
  },
  {
    header: "Patients With Outstanding Treatments",
    accessorKey: "patients_with_outstanding_treatments",
    size: 300,
    enableSorting: false,
  },
]

export const DailyProductionGoalTableConfig: MRT_ColumnDef<any>[] = [
  {
    header: "Metric Name",
    accessorKey: "metric_name",
    enableEditing: false,
    enableSorting: false,
    muiTableBodyCellProps: {
      align: "left",
      sx: {
        height: "48px",
        border: "0.5px solid #E4E4E4",
        boxShadow: "#00000022 1.95px 0px 2.6px",
        color: "black",
        fontWeight: "600",
      },
    },
  },
  {
    accessorKey: "mtd_budget",
    header: "MTD Budget",
    enableEditing: false,
    Cell: amountFormatter,
  },
  {
    accessorKey: "mtd_actual",
    header: "MTD Actual",
    enableEditing: false,
    Cell: amountFormatter,
  },
  {
    accessorKey: "mtd_variance",
    header: "Variance",
    enableEditing: false,
    Cell: amountFormatter,
    muiTableBodyCellProps: ({ cell }: any) => ({
      sx: {
        border:
          cell.getValue() > 0
            ? "1px solid #FFFFFF"
            : cell.getValue() < 0
            ? "1px solid #FFFFFF"
            : null,
        backgroundColor:
          cell.getValue() > 0
            ? colors.primaryGreen
            : cell.getValue() < 0
            ? colors.primaryRed
            : "#FFFFFF",
        color: cell.getValue() == 0 ? colors.primaryBlack : colors.primaryWhite,
      },
    }),
  },
  {
    accessorKey: "month_end_goal",
    header: "Month End Goal",
    enableEditing: false,
    Cell: amountFormatter,
    muiTableBodyCellProps: () => ({
      sx: {
        borderLeft: "1px solid #E4E4E4",
      },
    }),
  },
  {
    accessorKey: "projected_amount",
    header: "Projected Amount",
    enableEditing: false,
    Cell: amountFormatter,
  },
  {
    accessorKey: "projected_variance",
    header: "Projected Variance",
    enableEditing: false,
    Cell: amountFormatter,
    muiTableBodyCellProps: ({ cell }: any) => ({
      sx: {
        border:
          cell.getValue() > 0
            ? "1px solid #FFFFFF"
            : cell.getValue() < 0
            ? "1px solid #FFFFFF"
            : null,
        backgroundColor:
          cell.getValue() > 0
            ? colors.primaryGreen
            : cell.getValue() < 0
            ? colors.primaryRed
            : "#FFFFFF",
        color: cell.getValue() == 0 ? colors.primaryBlack : colors.primaryWhite,
      },
    }),
  },
  {
    accessorKey: "adjusted_daily_goal",
    header: "Adjusted Daily Goal",
    enableEditing: false,
    Cell: amountFormatter,
    muiTableBodyCellProps: ({ cell, row }: any) => {
      const getBgColor = (val: any) => {
        if (cell.getValue() > val) {
          return colors.primaryRed
        } else {
          return colors.primaryGreen
        }
      }

      return {
        sx: {
          border:
            cell.getValue() > 0
              ? "1px solid #FFFFFF"
              : cell.getValue() < 0
              ? "1px solid #FFFFFF"
              : null,
          backgroundColor:
            row?.original?.metric_name == "Production"
              ? getBgColor(huddleSummaryData?.dailyProductionGoalValue)
              : row?.original?.metric_name == "Collection"
              ? getBgColor(huddleSummaryData?.dailyCollectionGoalValue)
              : colors.primaryWhite,
          color:
            cell.getValue() == 0 ? colors.primaryBlack : colors.primaryWhite,
        },
      }
    },
  },
]

export const HuddleSummaryYesterdayTableConfig: MRT_ColumnDef<any>[] = [
  {
    header: "Metric Name",
    accessorKey: "metric_name",
    // size: 220,
    enableEditing: false,
    enableSorting: false,
    muiTableBodyCellProps: {
      align: "left",
      sx: {
        height: "48px",
        border: "0.5px solid #E4E4E4",
        boxShadow: "#00000022 1.95px 0px 2.6px",
        color: "black",
        fontWeight: "600",
      },
    },
  },
  {
    accessorKey: "goal",
    header: "Goal",
    enableEditing: false,
    Cell: amountFormatter,
  },
  {
    accessorKey: "actual",
    header: "Actual",
    enableEditing: false,
    Cell: amountFormatter,
  },
  {
    accessorKey: "variance",
    header: "Variance",
    enableEditing: false,
    Cell: (cellProps: any) => <Box>{amountFormatter(cellProps)}</Box>,
    muiTableBodyCellProps: ({ cell }: any) => ({
      sx: {
        padding: "0px 5%",
        "& div": {
          display: "flex",
          margin: "auto",
          justifyContent: "center",
          padding: "3%",

          border:
            cell.getValue() > 0
              ? "1px solid #FFFFFF"
              : cell.getValue() < 0
              ? "1px solid #FFFFFF"
              : null,
          backgroundColor:
            cell.getValue() > 0
              ? colors.primaryGreen
              : cell.getValue() < 0
              ? colors.primaryRed
              : "#FFFFFF",
          color:
            cell.getValue() == 0 ? colors.primaryBlack : colors.primaryWhite,
        },
      },
    }),
  },
]

export const HuddleSummaryKeyMetricsTableConfigStatic: MRT_ColumnDef<any>[] = [
  {
    header: "Name",
    accessorKey: "key_metric_name",
    enableEditing: false,
    enableSorting: false,
    muiTableBodyCellProps: {
      align: "left",
      sx: {
        height: "48px",
        border: "0.5px solid #E4E4E4",
        boxShadow: "#00000022 1.95px 0px 2.6px",
        color: "black",
        fontWeight: "600",
      },
    },
    // maxSize: 80
  },
  // {
  //   accessorKey: "yesterday",
  //   header: "Yesterday",
  //   enableEditing: false,
  //   Cell: amountFormatter,
  // },
  // {
  //   accessorKey: "today",
  //   header: "Today",
  //   enableEditing: false,
  //   Cell: amountFormatter,
  // },
]

export const ActiveOpportuntiesTableConfig: MRT_ColumnDef<any>[] = [
  {
    header: "Opportunity",
    accessorKey: "opportunity",
    // size: 220,
    enableEditing: false,
    enableSorting: false,
    muiTableBodyCellProps: {
      align: "left",
      sx: {
        height: "48px",
        border: "0.5px solid #E4E4E4",
        boxShadow: "#00000022 1.95px 0px 2.6px",
        color: "black",
        fontWeight: "600",
      },
    },
  },
  // {
  //   accessorKey: "start_date",
  //   header: "Start Date",
  //   enableEditing: false,
  // },
  {
    accessorKey: "end_date",
    header: "End Date",
    enableEditing: false,
  },
  {
    accessorKey: "target_column",
    header: "Target KPI",
    enableEditing: false,
    Cell: ({ renderedCellValue }: any) =>
      `${splitFirstCap(renderedCellValue, "_")}`,
  },
  {
    accessorKey: "target_value",
    header: "Start Value",
    enableEditing: false,
    Cell: ({ renderedCellValue, row }: any) =>
      `${roundUp(
        renderedCellValue,
        row.original.target_column_data_type,
        row.original.metric_precision,
      )}`,
  },
  {
    accessorKey: "target_current_value",
    header: "Current Value",
    enableEditing: false,
    Cell: ({ renderedCellValue, row }: any) =>
      `${roundUp(
        renderedCellValue,
        row.original.target_column_data_type,
        row.original.metric_precision,
      )}`,
  },
  {
    accessorKey: "percent_difference",
    header: "% Difference",
    enableEditing: false,
    Cell: ({ renderedCellValue }) => <Box>{`${renderedCellValue} % `}</Box>,
    muiTableBodyCellProps: ({ cell }: any) => ({
      sx: {
        padding: "0px 4%",
        "& div": {
          display: "flex",
          margin: "auto",
          justifyContent: "center",
          padding: "3%",

          border:
            cell?.row?.original?.percent_difference_highlighting != null
              ? "1px solid #FFFFFF"
              : "none",

          backgroundColor:
            cell?.row?.original?.percent_difference_highlighting === "green"
              ? colors.primaryGreen
              : cell?.row?.original?.percent_difference_highlighting === "red"
              ? colors.primaryRed
              : "#FFFFFF",
          color:
            cell?.row?.original?.percent_difference_highlighting == null
              ? colors.primaryBlack
              : colors.primaryWhite,
        },
      },
    }),
  },
]

export const ProviderSummaryFixedTableConfig: MRT_ColumnDef<any>[] = [
  {
    header: "Provider",
    accessorKey: "provider_name",
    enableEditing: false,
    enableSorting: false,
    muiTableBodyCellProps: {
      align: "left",
      sx: {
        height: "48px",
        border: "0.5px solid #E4E4E4",
        boxShadow: "#00000022 1.95px 0px 2.6px",
        color: "black",
        fontWeight: "600",
      },
    },
  },
]

export const ProviderSummaryTableConfigStatic: MRT_ColumnDef<any>[] = [
  {
    id: "provider",
    header: "",
    muiTableHeadCellProps: {
      sx: {
        backgroundColor: "#FFFFFF",
        borderRight: "1px solid #000000",
        zIndex: "10",
      },
    },
    columns: [
      {
        header: "Provider",
        accessorKey: "provider_name",
        enableEditing: false,
        enableSorting: false,
        muiTableBodyCellProps: {
          align: "left",
          sx: {
            height: "48px",
            border: "0.5px solid #E4E4E4",
            boxShadow: "#00000022 1.95px 0px 2.6px",
            color: "black",
            fontWeight: "600",
          },
        },
      },
    ],
  },
  {
    id: "yesterday", //id used to define `group` column
    header: "Yesterday",
    muiTableHeadCellProps: {
      sx: {
        backgroundColor: "#FFFFFF",
        borderRight: "1px solid #000000",
      },
    },
    columns: [
      {
        accessorKey: "yesterday.y_hourly_goal",
        header: "Hourly Goal",
        enableEditing: false,
        // Header: ({ header, column }: any) => <HuddleProviderSummaryHeader header={header} column={column} />
      },
      {
        accessorKey: "yesterday.y_hours",
        header: "Hours",
        enableEditing: (row: any) => {
          return row?.original?.yesterday.y_hours == null ? false : true
        },
        // Header: ({ header, column }: any) => <HuddleProviderSummaryHeader header={header} column={column} />,
        Cell: ({ renderedCellValue, table, cell }: any) => {
          const editingEnabled = table?.options?.enableEditing
          return (
            <Box
              sx={{
                display: "flex",
                justifyContent: editingEnabled ? "space-between" : "center",
                alignItems: "center",
              }}
            >
              <Box sx={{ flex: 1 }}></Box>
              <Box sx={{ flex: 1 }}>{renderedCellValue}</Box>
              {editingEnabled && cell.getValue() && (
                <Box sx={{ flex: 1 }}>
                  <IconButton
                    disableTouchRipple
                    onClick={() => {
                      table.setEditingCell(cell)
                    }}
                  >
                    <img
                      src={EditIcon}
                      height={"12px"}
                      alt="edit hours"
                      style={{ cursor: "pointer" }}
                    />
                  </IconButton>
                </Box>
              )}
            </Box>
          )
        },
      },
      {
        accessorKey: "yesterday.y_daily_prod_goal",
        header: "Daily Prod Goal",
        enableEditing: false,
        // Header: ({ header, column }: any) => <HuddleProviderSummaryHeader header={header} column={column} />
      },
      {
        accessorKey: "yesterday.y_actual_produced",
        header: "Actual Prod",
        enableEditing: false,
        // Header: ({ header, column }: any) => <HuddleProviderSummaryHeader header={header} column={column} />
      },
      {
        accessorKey: "yesterday.y_variance",
        header: "Variance",
        enableEditing: false,
        // Header: ({ header, column }: any) => <HuddleProviderSummaryHeader header={header} column={column} />,
        muiTableBodyCellProps: ({ cell }: any) => ({
          sx: {
            border:
              cell.getValue() > 0
                ? "1px solid #FFFFFF"
                : cell.getValue() < 0
                ? "1px solid #FFFFFF"
                : null,
            backgroundColor:
              cell.getValue() > 0
                ? colors.primaryGreen
                : cell.getValue() < 0
                ? colors.primaryRed
                : "#FFFFFF",
            color:
              cell.getValue() == 0 ? colors.primaryBlack : colors.primaryWhite,
          },
        }),
      },
    ],
  },
  {
    id: "today", //id used to define `group` column
    header: "Today",
    muiTableHeadCellProps: {
      sx: {
        backgroundColor: "#FFFFFF",
        borderRight: "1px solid #000000",
      },
    },
    columns: [
      {
        accessorKey: "today.t_daily_prod_goal",
        header: "Daily Prod Goal",
        enableEditing: false,
        // Header: ({ header, column }: any) => <HuddleProviderSummaryHeader header={header} column={column} />
      },
      {
        accessorKey: "today.t_scheduled_production",
        header: "Sch Prod",
        enableEditing: false,
        // Header: ({ header, column }: any) => <HuddleProviderSummaryHeader header={header} column={column} />
      },
      {
        accessorKey: "today.t_variance",
        header: "Variance",
        enableEditing: false,
        // Header: ({ header, column }: any) => <HuddleProviderSummaryHeader header={header} column={column} />,
        muiTableBodyCellProps: ({ cell }: any) => ({
          sx: {
            border:
              cell.getValue() > 0
                ? "1px solid #FFFFFF"
                : cell.getValue() < 0
                ? "1px solid #FFFFFF"
                : null,
            backgroundColor:
              cell.getValue() > 0
                ? colors.primaryGreen
                : cell.getValue() < 0
                ? colors.primaryRed
                : "#FFFFFF",
            color:
              cell.getValue() == 0 ? colors.primaryBlack : colors.primaryWhite,
          },
        }),
      },
    ],
  },
]

export const ProviderSummaryTableConfigStatic1: MRT_ColumnDef<any>[] = [
  {
    header: "Provider",
    accessorKey: "provider_name",
    enableEditing: false,
    enableSorting: false,
    muiTableBodyCellProps: {
      align: "left",
      sx: {
        height: "48px",
        border: "0.5px solid #E4E4E4",
        boxShadow: "#00000022 1.95px 0px 2.6px",
        color: "black",
        fontWeight: "600",
      },
    },
  },
  {
    accessorKey: "yesterday.y_hourly_goal",
    header: "Hourly Goal",
    enableEditing: false,
    Header: ({ header, column }: any) => (
      <HuddleProviderSummaryHeader header={header} column={column} />
    ),
  },
  {
    accessorKey: "yesterday.y_hours",
    header: "Hours",
    enableEditing: (row: any) => {
      return row?.original?.yesterday.y_hours == null ? false : true
    },
    Header: ({ header, column }: any) => (
      <HuddleProviderSummaryHeader header={header} column={column} />
    ),
    Cell: ({ renderedCellValue, table, cell }: any) => {
      const editingEnabled = table?.options?.enableEditing
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: editingEnabled ? "space-between" : "center",
            alignItems: "center",
          }}
        >
          <Box sx={{ flex: 1 }}></Box>
          <Box sx={{ flex: 1 }}>{renderedCellValue}</Box>
          {editingEnabled && cell.getValue() && (
            <Box sx={{ flex: 1 }}>
              <IconButton
                disableTouchRipple
                onClick={() => {
                  table.setEditingCell(cell)
                }}
              >
                <img
                  src={EditIcon}
                  height={"12px"}
                  alt="edit hours"
                  style={{ cursor: "pointer" }}
                />
              </IconButton>
            </Box>
          )}
        </Box>
      )
    },
  },
  {
    accessorKey: "yesterday.y_daily_prod_goal",
    header: "Daily Prod Goal",
    enableEditing: false,
    Header: ({ header, column }: any) => (
      <HuddleProviderSummaryHeader header={header} column={column} />
    ),
  },
  {
    accessorKey: "yesterday.y_actual_produced",
    header: "Actual Prod",
    enableEditing: false,
    Header: ({ header, column }: any) => (
      <HuddleProviderSummaryHeader header={header} column={column} />
    ),
  },
  {
    accessorKey: "yesterday.y_variance",
    header: "Variance",
    enableEditing: false,
    Header: ({ header, column }: any) => (
      <HuddleProviderSummaryHeader header={header} column={column} />
    ),
    muiTableBodyCellProps: ({ cell }: any) => ({
      sx: {
        border:
          cell.getValue() > 0
            ? "1px solid #FFFFFF"
            : cell.getValue() < 0
            ? "1px solid #FFFFFF"
            : null,
        backgroundColor:
          cell.getValue() > 0
            ? colors.primaryGreen
            : cell.getValue() < 0
            ? colors.primaryRed
            : "#FFFFFF",
        color: cell.getValue() == 0 ? colors.primaryBlack : colors.primaryWhite,
      },
    }),
  },
  {
    accessorKey: "today.t_daily_prod_goal",
    header: "Daily Prod Goal",
    enableEditing: false,
    Header: ({ header, column }: any) => (
      <HuddleProviderSummaryHeader header={header} column={column} />
    ),
  },
  {
    accessorKey: "today.t_scheduled_production",
    header: "Sch Prod",
    enableEditing: false,
    Header: ({ header, column }: any) => (
      <HuddleProviderSummaryHeader header={header} column={column} />
    ),
  },
  {
    accessorKey: "today.t_variance",
    header: "Variance",
    enableEditing: false,
    Header: ({ header, column }: any) => (
      <HuddleProviderSummaryHeader header={header} column={column} />
    ),
    muiTableBodyCellProps: ({ cell }: any) => ({
      sx: {
        border:
          cell.getValue() > 0
            ? "1px solid #FFFFFF"
            : cell.getValue() < 0
            ? "1px solid #FFFFFF"
            : null,
        backgroundColor:
          cell.getValue() > 0
            ? colors.primaryGreen
            : cell.getValue() < 0
            ? colors.primaryRed
            : "#FFFFFF",
        color: cell.getValue() == 0 ? colors.primaryBlack : colors.primaryWhite,
      },
    }),
  },
]
export const ProviderSummaryYesterdayTableConfigStatic: MRT_ColumnDef<any>[] = [
  {
    accessorKey: "yesterday.y_hourly_goal",
    header: "Hourly Goal",
    enableEditing: false,
  },
  {
    accessorKey: "yesterday.y_hours",
    header: "Hours",
    enableEditing: true,
    Cell: ({ renderedCellValue, table, cell }) => {
      const editingEnabled = table?.options?.enableEditing
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: editingEnabled ? "space-between" : "center",
            alignItems: "center",
          }}
        >
          <Box sx={{ flex: 1 }}></Box>
          <Box sx={{ flex: 1 }}>{renderedCellValue}</Box>
          {editingEnabled && (
            <Box sx={{ flex: 1 }}>
              <IconButton
                disableTouchRipple
                onClick={() => {
                  table.setEditingCell(cell)
                }}
              >
                <img
                  src={EditIcon}
                  height={"12px"}
                  alt="edit hours"
                  style={{ cursor: "pointer" }}
                />
              </IconButton>
            </Box>
          )}
        </Box>
      )
    },
  },
  {
    accessorKey: "yesterday.y_daily_prod_goal",
    header: "Daily Prod Goal",
    enableEditing: false,
  },
  {
    accessorKey: "yesterday.y_actual_produced",
    header: "Actual Prod",
    enableEditing: false,
  },
  {
    accessorKey: "yesterday.y_variance",
    header: "Variance",
    enableEditing: false,
    muiTableBodyCellProps: ({ cell }: any) => ({
      sx: {
        border:
          cell.getValue() > 0
            ? "1px solid #FFFFFF"
            : cell.getValue() < 0
            ? "1px solid #FFFFFF"
            : null,
        backgroundColor:
          cell.getValue() > 0
            ? colors.primaryGreen
            : cell.getValue() < 0
            ? colors.primaryRed
            : "#FFFFFF",
        color: cell.getValue() == 0 ? colors.primaryBlack : colors.primaryWhite,
      },
    }),
  },
]
export const ProviderSummaryTodayTableConfigStatic: MRT_ColumnDef<any>[] = [
  {
    accessorKey: "today.t_daily_prod_goal",
    header: "Daily Prod Goal",
    enableEditing: false,
  },
  {
    accessorKey: "today.t_scheduled_production",
    header: "Sch Prod",
    enableEditing: false,
  },
  {
    accessorKey: "today.t_variance",
    header: "Variance",
    enableEditing: false,
    muiTableBodyCellProps: ({ cell }: any) => ({
      sx: {
        border:
          cell.getValue() > 0
            ? "1px solid #FFFFFF"
            : cell.getValue() < 0
            ? "1px solid #FFFFFF"
            : null,
        backgroundColor:
          cell.getValue() > 0
            ? colors.primaryGreen
            : cell.getValue() < 0
            ? colors.primaryRed
            : "#FFFFFF",
        color: cell.getValue() == 0 ? colors.primaryBlack : colors.primaryWhite,
      },
    }),
  },
]
export const TodayAuditTableConfig: MRT_ColumnDef<any>[] = [
  {
    header: "Patient Name",
    accessorKey: "patient_name",
    // size: 220,
    enableEditing: false,
    enableSorting: false,
    muiTableBodyCellProps: {
      align: "left",
      sx: {
        height: "48px",
        border: "0.5px solid #E4E4E4",
        boxShadow: "#00000022 1.95px 0px 2.6px",
        color: "black",
        fontWeight: "600",
      },
    },
  },
  {
    accessorKey: "time.value",
    header: "Appt. Time",
    enableEditing: false,
  },
  {
    accessorKey: "status.value",
    header: "Appt. Status",
    enableEditing: false,
  },
  {
    accessorKey: "missing_exam.is_highlight",
    header: "Missing Exam",
    enableEditing: false,
    Cell: ({ renderedCellValue, row }) =>
      colorDot(row.original.missing_exam.is_highlight),
  },
  {
    accessorKey: "missing_bitewing.is_highlight",
    header: "Missing Bitewing",
    enableEditing: false,
    Cell: ({ renderedCellValue, row }) =>
      colorDot(row.original.missing_bitewing.is_highlight),
  },
  {
    accessorKey: "cell_number.is_highlight",
    header: "Valid Cell #",
    enableEditing: false,
    Cell: ({ renderedCellValue, row }) =>
      colorDot(row.original.cell_number.is_highlight),
  },
  {
    accessorKey: "email.is_highlight",
    header: "Valid Email",
    enableEditing: false,
    Cell: ({ renderedCellValue, row }) =>
      colorDot(row.original.email.is_highlight),
  },
  {
    accessorKey: "no_show_risk.is_highlight",
    header: "No Show Risk",
    enableEditing: false,
    Cell: ({ renderedCellValue, row }) =>
      colorDot(row.original.no_show_risk.is_highlight),
  },
  {
    accessorKey: "cancelled_appt.is_highlight",
    header: "Cancelled Appt.",
    enableEditing: false,
    Cell: ({ renderedCellValue, row }) =>
      colorDot(row.original.cancelled_appt.is_highlight),
  },
  {
    accessorKey: "unscheduled_tx.is_highlight",
    header: "Unsched Tx",
    enableEditing: false,
    Cell: ({ renderedCellValue, row }) =>
      colorDot(row.original.unscheduled_tx.is_highlight),
  },
  {
    accessorKey: "future_recall_appt.is_highlight",
    header: "Fut Recall Appt.",
    enableEditing: false,
    Cell: ({ renderedCellValue, row }) =>
      colorDot(row.original.future_recall_appt.is_highlight),
  },
]
export const YesterdayAuditTableConfig: MRT_ColumnDef<any>[] = [
  {
    header: "Patient Name",
    accessorKey: "patient_name",
    size: 220,
    enableEditing: false,
    enableSorting: false,
    muiTableBodyCellProps: {
      align: "left",
      sx: {
        height: "48px",
        border: "0.5px solid #E4E4E4",
        boxShadow: "#00000022 1.95px 0px 2.6px",
        color: "black",
        fontWeight: "600",
      },
    },
  },
  {
    accessorKey: "time.value",
    header: "Appt. Time",
    enableEditing: false,
  },
  {
    accessorKey: "patient_charged_out.is_highlight",
    header: "Pt Chargd Out",
    enableEditing: false,
    Cell: ({ renderedCellValue, row }) =>
      colorDot(row.original.patient_charged_out.is_highlight),
  },
  {
    accessorKey: "missing_exam.is_highlight",
    header: "Missing Exam",
    enableEditing: false,
    Cell: ({ renderedCellValue, row }) =>
      colorDot(row.original.missing_exam.is_highlight),
  },
  {
    accessorKey: "missing_bitewing.is_highlight",
    header: "Missing Bitewing",
    enableEditing: false,
    Cell: ({ renderedCellValue, row }) =>
      colorDot(row.original.missing_bitewing.is_highlight),
  },
  {
    accessorKey: "cell_number.is_highlight",
    header: "Valid Cell #",
    enableEditing: false,
    Cell: ({ renderedCellValue, row }) =>
      colorDot(row.original.cell_number.is_highlight),
  },
  {
    accessorKey: "email.is_highlight",
    header: "Valid Email",
    enableEditing: false,
    Cell: ({ renderedCellValue, row }) =>
      colorDot(row.original.email.is_highlight),
  },
  {
    accessorKey: "no_show.is_highlight",
    header: "No Show",
    enableEditing: false,
    Cell: ({ renderedCellValue, row }) =>
      colorDot(row.original.no_show.is_highlight),
  },
  {
    accessorKey: "unscheduled_tx.is_highlight",
    header: "Unsched Tx",
    enableEditing: false,
    Cell: ({ renderedCellValue, row }) =>
      colorDot(row.original.unscheduled_tx.is_highlight),
  },
  {
    accessorKey: "missing_recall_appt.is_highlight",
    header: "Missing Recall Appt.",
    enableEditing: false,
    Cell: ({ renderedCellValue, row }) =>
      colorDot(row.original.missing_recall_appt.is_highlight),
  },
  {
    accessorKey: "claim_status.value",
    header: "Claim Status",
    enableEditing: false,
  },
]

export const HuddleSummaryFutureStatic: MRT_ColumnDef<any>[] = [
  {
    header: "Metric Name",
    accessorKey: "metric_name",
    enableEditing: false,
    enableSorting: false,
    muiTableBodyCellProps: {
      align: "left",
      sx: {
        height: "48px",
        border: "0.5px solid #E4E4E4",
        boxShadow: "#00000022 1.95px 0px 2.6px",
        color: "black",
        fontWeight: "600",
      },
    },
  },
]
